/* eslint-disable max-len */
import React from 'react';
import './style.scss';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase';
import getCloudinary from '../../utils/getCloudinary';
import DrWatsonSmallLogoWhite from '../../images/logo/dr-watson-large-logo-white.svg';

export const SUBSCRIPTION_MODAL = 'subscriptionModal';
const SubscriptionModal = () => {
// eslint-disable-next-line no-undef
    const [showSubscriptionModal, setShowSubscriptionModal] = React.useState(localStorage.getItem(SUBSCRIPTION_MODAL) !== 'true');
    // eslint-disable-next-line no-unused-vars
    const [authUser, userInitialising, userError] = typeof window !== 'undefined' ? useAuthState(firebase.auth()) : Array(3);

    return (
        <div className={`modal ${showSubscriptionModal && 'is-active'} subscription-modal`}>
            <div className="modal-background" />
            <div
                className="modal-content subscription-modal-content"
                style={{
                    backgroundImage: `url("${getCloudinary().url(
                        'dashboard-uploads/cannabis-hand_ir4xqv',
                        { height: 500, crop: 'fit', fetch_format: 'auto' },
                    )}")`,
                }}
            >
                <div className="image-dimmer" />
                <div className="foreground">
                    <span
                        className="icon is-large cursor-pointer has-text-white close-modal"
                        onClick={() => {
                            setShowSubscriptionModal(false);
                            // eslint-disable-next-line no-undef
                            localStorage.setItem(SUBSCRIPTION_MODAL, new Date().getTime());
                        }}
                    >
                        <i className="fas fa-times" />
                    </span>

                    <img
                        alt="DR WATSON Logo"
                        className="dr-watson-logo-small-form"
                        src={DrWatsonSmallLogoWhite}
                    />
                    <lottie-player
                        src="https://assets1.lottiefiles.com/packages/lf20_JZEZvh.json"
                        background="transparent"
                        speed="0.6"
                        style={{
                            width: 130,
                            height: 130,
                        }}
                        // loop
                        autoplay
                    />

                    <div
                        className="title is-size-5-touch is-size-4-desktop has-text-centered-touch is-spaced has-text-white"
                    >
                        {'You\'ve found a gift!'}
                    </div>
                    <div className="subtitle is-size-6-touch is-size-5-desktop has-text-centered-touch has-text-white">
                        Receive 20% off your first purchase for simply subscribing to our mailing list!
                    </div>
                    <form
                        id="mc-embedded-subscribe-form"
                        className="validate"
                        action="https://maverixx.us20.list-manage.com/subscribe/post?u=3a0038d21a717327aa3a61f27&amp;id=926f8982eb"
                        method="post"
                        name="mc-embedded-subscribe-form"
                        target="_blank"
                    >
                        <div className="field has-addons subscribe-form">
                            <div className="control">
                                <input
                                    id="mce-EMAIL"
                                    name="EMAIL"
                                    className="input is-large required email"
                                    type="email"
                                    placeholder="Your email address"
                                    defaultValue={authUser ? authUser.email : ''}
                                />
                            </div>
                            <div className="control">
                                <input
                                    hidden
                                    checked
                                    type="checkbox"
                                    id="gdpr_22049"
                                    name="gdpr[22049]"
                                    value="Y"
                                    className="av-checkbox "
                                />
                                <button
                                    id="mc-embedded-subscribe"
                                    type="submit"
                                    className="button is-large is-info"
                                >
                                    Subscribe
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionModal;
